import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import resizeImageUrl from '@afosto/utils/resizeImageUrl';

const ParcelItem = ({ item }) => {
  const intl = useIntl();

  return (
    <Grid key={item.id} item xs={12}>
      <Card>
        <Box display="flex" flexWrap="nowrap" alignItems="center">
          <Box flexGrow={1}>
            <CardContent>
              <List disablePadding>
                <ListItem disableGutters>
                  <ListItemAvatar>
                    <Avatar src={item?.product && resizeImageUrl(item?.product?.image, 50)} />
                  </ListItemAvatar>
                  <ListItemText primary={item.description} secondary={item.sku} />
                </ListItem>
              </List>
              <Grid container spacing={1}>
                <Grid item xs={4}>
                  <Typography variant="overline" color="textSecondary">
                    {intl.formatMessage({
                      id: 'dataGrid.columns.shippingItems.quantity',
                      defaultMessage: 'Quantity',
                      description: 'The column name for column quantity',
                    })}
                  </Typography>
                  <Typography variant="body2" color="textPrimary">
                    {item.quantity}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Box>
        </Box>
      </Card>
    </Grid>
  );
};

ParcelItem.propTypes = {
  item: PropTypes.object.isRequired,
};

export default ParcelItem;
